<fcom-modal
  [open]="modalOpen"
  [title]="'kidsInBusinessNotification.modalTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fullHeight]="true"
  (close)="closeModal()"
  data-testid="air-lounge-modal"
>
  <div class="nordic-blue-900-text pr-large-x pr-small-y">
    <cms-rich-text
      *ngFor="let article of content$ | async; let isLast = last"
      data-testid="first-content"
      [content$]="article | finToObservable"
      [headerStyles]="headerStyles"
      [extraClasses]="isLast ? undefined : 'mr-large-b'"
    ></cms-rich-text>
    <div class="mr-large-t">
      <fcom-checkbox
        [id]="'kids-in-busines-notification-checkbox'"
        [name]="'kids-in-busines-notification-checkbox'"
        data-testid="kids-in-business-notification-checkbox"
        (change)="onCheckboxChange($event)"
      >
        <span class="font-body-1 medium-type">
          {{ 'kidsInBusinessNotification.checkboxLabel' | finLocalization }}
        </span>
      </fcom-checkbox>
    </div>
    <div #errorMessage>
      <div *ngIf="showErrorMessage" class="pr-small-t font-body-1 error-900-text" data-testid="error-message">
        {{ 'kidsInBusinessNotification.errorMessage' | finLocalization }}
      </div>
    </div>
  </div>
  <div buttons>
    <fcom-button
      [text]="'kidsInBusinessNotification.cancelButton' | finLocalization"
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      [mode]="ButtonMode.FILL_MOBILE"
      [aria]="{ label: 'kidsInBusinessNotification.cancelButton' | finLocalization, role: 'button' }"
      (clickBtn)="emitCancel()"
      class="mr-xsmall-t mr-xxsmall-b mr-xxsmall-x"
      data-testid="cancel-button"
    ></fcom-button>
    <fcom-button
      [text]="'kidsInBusinessNotification.continueButton' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [mode]="ButtonMode.FILL_MOBILE"
      [aria]="{ label: 'kidsInBusinessNotification.continueButton' | finLocalization, role: 'button' }"
      (clickBtn)="emitContinue()"
      class="mr-xsmall-t mr-xxsmall-b mr-xxsmall-x"
      data-testid="continue-button"
    ></fcom-button>
  </div>
</fcom-modal>
